export default __webpack_public_path__ + "static/media/diamondTop.07338fd0.svg";